export default "__VITE_ASSET__IrO99cZf__"